<template>
  <div>
    <list
      row-key="RechargeTempId"
      ref="list"
      unit="话费充值设置"
      :page="page"
      :show-checkbox="$permission.canWrite()"
      :show-query="false"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query"></template>
      <template slot="table">
        <el-table-column prop="Sort" label="序号" align="center" width="60" />
        <el-table-column prop="Amount" label="金额" />
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/consume/rechargetemp").default,
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>